import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { ProductRecipe, ProductRecipeSearch } from '../../models/product-recipe/product-recipe';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ProductRecipeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/product-recipe';

  getById(id: string): Observable<ApiResponse<ProductRecipe>> {
    return this.httpClient.get<ApiResponse<ProductRecipe>>(`${this.baseUrl}/${id}`);
  }

  getByOutputItemCode(itemCode: string): Observable<ApiResponse<ProductRecipe[]>> {
    return this.httpClient.get<ApiResponse<ProductRecipe[]>>(`${this.baseUrl}/by-output/${encodeURIComponent(itemCode)}`);
  }

  search(
    command: ProductRecipeSearch,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<ProductRecipe>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) url += `&sortField=${sortField}`;
    if (sortOrder !== undefined) url += `&sortOrder=${sortOrder}`;
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductRecipe>>>(url, command);
  }
}
